<template>
    <v-dialog v-model="isOpen" max-width="800">
        <v-card>
            <v-tabs v-model="selectedTab" bg-color="primary">
                <v-tab value="tab-main">Main</v-tab>
                <v-tab value="tab-variables">Variables</v-tab>
                <v-tab value="tab-container">Container</v-tab>
            </v-tabs>

            <v-card-text>
                <v-tabs-window v-model="selectedTab">
                    <v-tabs-window-item value="tab-main">
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                        disabled
                                        v-model="localItem.itemGuid"
                                        label="Item GUID"
                                    />
                                </v-col>

                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field
                                        :disabled="!isNew"
                                        v-model="localItem.itemHandle"
                                        label="Item Handle"
                                    />
                                </v-col>

                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        v-model="localItem.ownerGuid"
                                        label="Owner"
                                    />
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        v-model="localItem.spawnerGuid"
                                        label="Spawner"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field
                                        v-model="localItem.coordX"
                                        label="X"
                                        type="number"
                                        step="0.1"
                                    />
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field
                                        v-model="localItem.coordY"
                                        label="Y"
                                        type="number"
                                        step="0.1"
                                    />
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field
                                        v-model="localItem.coordZ"
                                        label="Z"
                                        type="number"
                                        step="0.1"
                                    />
                                </v-col>
                                <v-col cols="12" sm="3" md="3">
                                    <v-text-field
                                        v-model="localItem.rotation"
                                        label="Rotation"
                                        type="number"
                                        step="1"
                                    />
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        disabled
                                        v-model="localItem.createdAt"
                                        label="Created At"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        disabled
                                        v-model="localItem.updatedAt"
                                        label="Updated At"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-tabs-window-item>
                    <v-tabs-window-item value="tab-variables">
                        <v-textarea
                            rows="30"
                            v-model="localItem.properties"
                            style="
                                font-family: 'Consolas', 'Courier New',
                                    monospace;
                                font-size: 12px;
                            "
                            spellcheck="false"
                            autocorrect="off"
                            label="Properties"
                            @input="validateJsonProperties"
                        >
                        </v-textarea>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="tab-container">
                        <v-textarea
                            rows="30"
                            v-model="localItem.containerData"
                            style="
                                font-family: 'Consolas', 'Courier New',
                                    monospace;
                                font-size: 12px;
                            "
                            spellcheck="false"
                            autocorrect="off"
                            label="Container"
                            @input="validateJsonContainerData"
                        >
                        </v-textarea>
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-card-text>

            <v-card-actions>
                <span v-if="errorMessage" class="text-body-2 text-red mt-2 ml-6">{{ errorMessage }}</span>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    :disabled="isBusy"
                    text
                    @click="closeDialog"
                    >Close</v-btn
                >
                <v-btn
                    color="blue-darken-1"
                    :disabled="isBusy"
                    variant="text"
                    @click="saveAndClose"
                    >Save</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

const { v4: uuidv4 } = require('uuid');

export default {
    emits: ['request-reload-worlditems'],
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        selectedServer: null,
        selectedMap: null,
    },
    data() {
        return {
            isNew: false,
            errorMessage: '',
            selectedTab: null,
            jsonError: null,
            isBusy: false,
            localItem: { },
        };
    },
    watch: {
        item(newItem) {

            this.isNew = Object.keys(newItem).length === 0;
            this.localItem = {
                ...newItem,
                itemGuid: this.isNew ? uuidv4() : newItem.itemGuid,
                properties: newItem.properties === null
                    ? '{}'
                    : typeof newItem.properties === 'object'
                        ? JSON.stringify(newItem.properties, null, 2)
                        : JSON.stringify([{ name: '', value: ''}], null, 2),
                containerData: newItem.containerData === null
                    ? ''
                    : typeof newItem.containerData === 'object'
                        ? JSON.stringify(newItem.containerData, null, 2)
                        : '',
            };
        },
    },
    computed: {
        isOpen: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            },
        },
    },
    methods: {
        validateForSave() {

            if (this.validateJsonProperties())
                this.errorMessage = '';

            if (this.validateJsonContainerData())
                this.errorMessage = '';

            if (!this.localItem.itemHandle)
                this.errorMessage = 'Invalid handle.';

            if (!this.selectedServer)
                this.errorMessage = 'Invalid server.';

            if (!this.selectedMap)
                this.errorMessage = 'Invalid map.';

            if (isNaN(this.localItem.coordX))
                this.errorMessage = 'Invalid X coordinate.';

            if (isNaN(this.localItem.coordY))
                this.errorMessage = 'Invalid Y coordinate.';

            if (isNaN(this.localItem.coordZ))
                this.errorMessage = 'Invalid Z coordinate.';

            if (isNaN(this.localItem.rotation))
                this.errorMessage = 'Invalid rotation value.';

            return (this.errorMessage.length === 0);
        },
        validateJsonContainerData() {
            try {
                if (this.localItem.containerData === undefined
                || this.localItem.containerData.length === 0
                || JSON.parse(this.localItem.containerData))
                {
                    this.errorMessage = '';
                    return true;
                }
            }
            catch(error) {
                this.errorMessage = 'Invalid container data, malformed Json.' + error.errorMessage;
            }
            return false;
        },
        validateJsonProperties() {
            try {
                if (this.localItem.properties === undefined
                || this.localItem.properties.length === 0
                || JSON.parse(this.localItem.properties))
                {
                    this.errorMessage = '';
                    return true;
                }
            }
            catch(error) {
                this.errorMessage = 'Invalid properties, malformed Json.';
            }
            return false;
        },
        closeDialog() {
            this.$emit('update:modelValue', false);
        },
        saveAndClose() {
            if (this.validateForSave())
            {
                const body = [{
                    itemGuid: this.localItem.itemGuid,
                    itemHandle: this.localItem.itemHandle,
                    ownerGuid: this.localItem.ownerGuid,
                    spawnerGuid: this.localItem.spawnerGuid,
                    coordX: this.localItem.coordX,
                    coordY: this.localItem.coordY,
                    coordZ: this.localItem.coordZ,
                    rotation: this.localItem.rotation,
                    properties: !this.localItem.properties ? null : JSON.parse(this.localItem.properties),
                    containerData: !this.localItem.containerData ? null : JSON.parse(this.localItem.containerData),
                }];

                const token = localStorage.getItem('Auth');
                this.isBusy = true;

                fetch(`${process.env.VUE_APP_STONECREEK_BACKEND}/api/v2/worlditems/${this.selectedServer}/${this.selectedMap}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(body)
                })
                .then(async (response) => {
                    this.isBusy = false;
                    if (!response.ok) {
                        const json = await response.json();
                        this.errorMessage = json.error || 'Unknown error occurred.';
                    }
                    else {
                        this.errorMessage = '';
                        this.$emit('update:modelValue', false);
                        this.$emit('request-reload-worlditems');
                    }
                });
            }
        },
    },
};
</script>
